export const ENABLE_LOADING = true
export const DISABLE_LOADING = false

export const ENABLE_MODAL = true
export const DISABLE_MODAL = false

export const DEBOUNCE_TIMEOUT = 1500
